<template>
  <b-card :title="cid ? 'Company Settings' : 'New Company'">
    <b-form @submit.prevent="save">
      <b-form-row>
        <b-col md="6">
          <b-form-group
            label="Parent Company Name">
            <b-form-input
              type="text"
              v-model="company.name">
            </b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            label="Customer ID">
            <b-form-input
              type="text"
              v-model="company.id">
            </b-form-input>
          </b-form-group>
        </b-col>
      </b-form-row>
      <b-btn variant="primary" type="submit" class="mt-3">Save</b-btn>
    </b-form>
  </b-card>
</template>

<script>
  import { CompanyApi } from "../api";

  export default {
      name: 'CompanySettings',
      props: {
          cid: { required: false }
      },
      created () {
        if (this.cid) {
            CompanyApi.details(this.cid).then((company) => {
                this.company = company
            })
        }
      },
      data () {
          return {
              company: {
                  id: this.cid
              }
          }
      },
      methods: {
          save () {
              CompanyApi.save(this.company).then((co) => {
                  if(!this.cid) {
                      this.$notify.success('Company created')
                      this.$router.push({ name: 'AdminCompanyProfile', params: { cid: co.id } })
                  } else {
                      this.$notify.success('Company details saved')
                  }
              })
          }
      }
  }
</script>



// WEBPACK FOOTER //
// src/company/pages/CompanySettings.vue